export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BUSINESS = {
  name: "Velocity Electrical Surplus",
  nameUpper: "VELOCITY ELECTRICAL SURPLUS",
  manager: "Nicolas Parker",
  phoneDisplay: "(586) 718-3404",
  phoneTel: "tel:+15867183404",
  sms: "sms:+15867183404",
  email: "velocityelectricsurplus@gmail.com",
  emailHref: "mailto:velocityelectricsurplus@gmail.com",
  address: "51550 Birch St, New Baltimore, MI 48047",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=51550+Birch+St+New+Baltimore+MI+48047",
  mapsEmbed:
    "https://maps.google.com/maps?q=51550%20Birch%20St%2C%20New%20Baltimore%2C%20MI%2048047&t=&z=13&ie=UTF8&iwloc=&output=embed",
  facebook: "https://www.facebook.com/share/1DWGpFXvx8/?mibextid=wwXIfr",
  slogan: "DON\u2019T SCRAP IT. SELL IT TO VELOCITY ELECTRICAL SURPLUS.",
};

const u = (id, w = 1200) =>
  `https://images.unsplash.com/${id}?crop=entropy&cs=srgb&fm=jpg&q=80&w=${w}&auto=format`;

export const IMAGES = {
  hero: u("photo-1553413077-190dd305871c", 1920),
  // Real product photography hosted locally (licensed via Wikimedia Commons — see Privacy page credits)
  wireReel: "/images/wire-reels.jpg", // Industrial electrical wire spools & cable reels (CC BY-SA 2.0, Tony Webster)
  breakers: "/images/circuit-breaker.jpg", // ABB SACE Tmax 630A molded-case circuit breaker (CC BY-SA 3.0, Balurbala)
  busPlugs: "/images/bus-plugs-busway.jpg", // Bus plugs installed on busway/bus duct (Public domain, Achim Hering)
  transformers: u("photo-1509390144018-eeaf65052242"),
  mcc: u("photo-1558054665-fbe00cd7d920"),
  disconnects: u("photo-1576446468729-7674e99608f5"),
  scrapCopper: u("photo-1714352069805-e0bf94d1381f"),
  panelboards: u("photo-1635335874521-7987db781153"),
  switchgear: u("photo-1509390484649-e8f3d1bb0b6d"),
  motors: u("photo-1649038780045-235e4b6e40b4"),
};
